import { connect } from 'react-redux'
import { compose, lifecycle, withProps, withHandlers } from 'recompose'
import { bindActionCreators } from 'redux'


import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as UserSelectors from 'app/modules/user/selectors'
import { makeHasGate } from 'app/modules/gates/selectors'


import SignatureEditor from './component'


const mapStateToProps = state => {
  const viewingSignatureId = PlaybookSelectors.viewingSignatureId(state)
  return {
    signatureIncludeAvatar: PlaybookSelectors.signatureIncludeAvatar(state),
    signatureIncludeSocial: PlaybookSelectors.signatureIncludeSocial(state),
    signatureIncludeBanner: PlaybookSelectors.signatureIncludeBanner(state),
    signatureBannerImgURL: PlaybookSelectors.signatureBannerImgURL(state, viewingSignatureId),
    signatureBannerLinkURL: PlaybookSelectors.signatureBannerLinkURL(state, viewingSignatureId),
    signatureBody: PlaybookSelectors.signatureBody(state),
    signatureBannerUploadPending: PlaybookSelectors.signatureBannerStatusPending(state),
    signaturePreviewAllData: PlaybookSelectors.signaturePreviewAllData(state),
    signaturePreviewAllFetchPending: PlaybookSelectors.signaturePreviewAllFetchPending(state),
    signaturePreviewAllFetchFailed: PlaybookSelectors.signaturePreviewAllFetchFailed(state),
    viewingSignatureId,
    signatures: PlaybookSelectors.signatures(state),
    currentUser: UserSelectors.currentUser(state),
  }
}


const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setViewingSignatureId: PlaybookActions.setViewingSignatureId,
      setSignatureIncludeAvatar: PlaybookActions.setSignatureIncludeAvatar,
      setSignatureIncludeSocial: PlaybookActions.setSignatureIncludeSocial,
      setSignatureIncludeBanner: PlaybookActions.setSignatureIncludeBanner,
      setSignatureBannerLinkURL: PlaybookActions.setSignatureBannerLinkURL,
      setSignatureBanner: PlaybookActions.setSignatureBanner,
      setSignatureBody: PlaybookActions.setSignatureBody,
      clearSignatureBanner: PlaybookActions.clearSignatureBanner,
      fetchSignatureMultiBannerPreview: PlaybookActions.fetchSignatureMultiBannerPreview,
      addNewBanner: PlaybookActions.addNewSignatureToPlaybook,
      addEmptyBannerSignature: PlaybookActions.addEmptyBannerSignature,
      removeEmptyBannerSignature: PlaybookActions.removeEmptyBannerSignature,
      removeSignature: PlaybookActions.removeSignature,
    },
    dispatch
  ),
})


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.actions.fetchSignatureMultiBannerPreview({ userId: this.props.currentUser.id , isPlaybookEditor: true })
    }
  }),
  withProps(props => ({
    emptyBannerChecked: props.signatures.filter(sig => sig.hasCampaignGraphic).size >= 1 && props.signatures.filter(sig => !sig.hasCampaignGraphic).size === 1
  })),
  withHandlers({
    onClearSignatureBanner: props => (e, signatureId) => {
      const {
        actions: {
          clearSignatureBanner,
          fetchSignatureMultiBannerPreview,
        },
        currentUser,
      } = props
      e.stopPropagation()
      clearSignatureBanner(signatureId)
      fetchSignatureMultiBannerPreview({ userId: currentUser.id })
    },
    onAddNewBanner: props => () => {
      const {
        actions: {
          addNewBanner
        }
      } = props
      addNewBanner()
    },
    onIncludeNoBannerOption: props => () => {
      if (!props.emptyBannerChecked) {
        props.actions.addEmptyBannerSignature()
      } else {
        props.actions.removeEmptyBannerSignature()
      }
    },
    onRemoveSignatureClick: props => (signatureId, numberOfBanners) => {
      if (numberOfBanners == 1) {
        props.actions.addNewBanner()
      }
      props.actions.removeSignature(signatureId)
      props.actions.fetchSignatureMultiBannerPreview({ userId: props.currentUser.id, isPlaybookEditor: true })
    },
    onRefetchPreviewClick: props => () => {
      props.actions.fetchSignatureMultiBannerPreview({ userId: props.currentUser.id, isPlaybookEditor: true })
    }
  }),
  withProps(props => {
    const {
      currentUser,
      actions: {
        fetchSignatureMultiBannerPreview,
        setSignatureIncludeAvatar,
        setSignatureIncludeSocial,
        setSignatureIncludeBanner,
        setSignatureBannerLinkURL,
        setSignatureBody,
        setSignatureBanner,
      },
      signatureBody,
    } = props

    const fetchPreview = fetchSignatureMultiBannerPreview.bind(null, { userId: currentUser.id })

    // decorator for simple actions that all do the same thing but also need to fetch the preview when they change
    const getPreviewAfter = (firstDo, callWith, timeout = 1) => {
      firstDo(callWith)
      setTimeout(fetchPreview, timeout)
    }

    const addHttp = (url) => url.startsWith('http') ? url : `http://`

    return {
      onIncludeAvatarChange: val => getPreviewAfter(setSignatureIncludeAvatar, val),
      onIncludeSocialChange: val => getPreviewAfter(setSignatureIncludeSocial, val),
      onIncludeBannerChange: val => getPreviewAfter(setSignatureIncludeBanner, val),
      onBannerLinkURLChange: (e, signatureId) => getPreviewAfter(setSignatureBannerLinkURL, { value: addHttp(e.target.value), signatureId }),
      onContentChange: val => val !== signatureBody ? getPreviewAfter(setSignatureBody, val) : null,
      onBannerUpload: (files, signatureId) => getPreviewAfter(setSignatureBanner, { file: files[0], signatureId }, 1500)
    }
  }),
)(SignatureEditor)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SignatureEditor/index.js